export enum SONG_CATEGORY {
  POP = 'POP',
  ALTERNATIVE_ROCK = 'ALTERNATIVE_ROCK',
  DANCE_ELECTRONIC = 'DANCE_ELECTRONIC',
  COUNTRY_FOLK = 'COUNTRY_FOLK',
  RAP_HIPHOP = 'RAP_HIPHOP',
  HARD_ROCK_METAL = 'HARD_ROCK_METAL',
}

const genreImagePath = '/concerts/genres';

export const genreCategoriesList = [
  {
    label: 'Pop',
    value: SONG_CATEGORY.POP,
    slug: 'rock-pop',
    image: `${genreImagePath}/rock-pop.png`,
  },
  {
    label: 'Rock',
    value: SONG_CATEGORY.ALTERNATIVE_ROCK,
    slug: 'alternative-rock',
    image: `${genreImagePath}/alternative-rock.png`,
  },
  {
    label: 'Dance/Electronic',
    value: SONG_CATEGORY.DANCE_ELECTRONIC,
    slug: 'dance-electronic',
    image: `${genreImagePath}/dance-electronic.png`,
  },
  {
    label: 'Country',
    value: SONG_CATEGORY.COUNTRY_FOLK,
    slug: 'country-folk',
    image: `${genreImagePath}/country-folk.png`,
  },
  {
    label: 'Hip-Hop',
    value: SONG_CATEGORY.RAP_HIPHOP,
    slug: 'rap-hip-hop',
    image: `${genreImagePath}/rap-hip-hop.png`,
  },
  {
    label: 'Metal',
    value: SONG_CATEGORY.HARD_ROCK_METAL,
    slug: 'hard-rock-metal',
    image: `${genreImagePath}/hard-rock-metal.png`,
  },
];
